/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CaseReportCaseDiagnosis } from './CaseReportCaseDiagnosis';
import type { CaseReportSignature } from './CaseReportSignature';
import type { LocationCode } from './LocationCode';

export type CaseReport = {
    readonly id?: number;
    readonly case_id?: number;
    readonly case_document_id?: number;
    readonly case_diagnosis?: Array<CaseReportCaseDiagnosis>;
    readonly signature?: CaseReportSignature;
    readonly user_id?: number;
    version: number;
    /**
     * report type
     */
    report_type?: CaseReport.report_type;
    serialization?: any;
    readonly created_at?: string;
    readonly updated_at?: string;
    readonly timezone?: string;
    location_code: LocationCode;
    report_json_version?: number;
}

export namespace CaseReport {

    /**
     * report type
     */
    export enum report_type {
        SCREEN = 'screen',
        FINALIZING = 'finalizing',
        AMEND = 'amend',
        ADDEND = 'addend',
        CORRECTION = 'correction',
    }


}
